import React from "react"

function TwoCol({contentOne, contentTwo}) {
    return(
        <div className="row">
            <div className="col">{contentOne}</div>
            <div className="col">{contentTwo}</div>
        </div>
    );
}

export default TwoCol